export const PORTAL_ADMIN_ROLE_CODE = 'YLSTN_ADMIN_METIER';
export const SUPER_ADMIN_ROLE_CODE = 'YLSTN_ISS_ADMIN_METIER';
export const BUSINESS_ADMIN_ROLE_CODE = 'YLSTN_CLIENT_ADMIN';
export const BUSINESS_ADMIN_TICKET_ROLE_CODE = 'YLSTN_CLIENT_ADMIN_TICKET';

// Roles granted every Portal Admin privilege. Add new back-office roles here.
export const BACKOFFICE_ROLE_CODES = [PORTAL_ADMIN_ROLE_CODE, SUPER_ADMIN_ROLE_CODE] as const;
export const SUPER_ADMIN_ROLE_CODES = [SUPER_ADMIN_ROLE_CODE] as const;
export const FRONTOFFICE_ROLE_CODES = [
  BUSINESS_ADMIN_ROLE_CODE,
  BUSINESS_ADMIN_TICKET_ROLE_CODE,
] as const;

// If you add a new role here, please also add it to the list of roles in the src/DTO/Invitation/CreateInvitationRequestBodyDTO.php
export const ALLOWED_ROLE_CODES_FOR_BACKOFFICE_INVITATION: ApiRoleCode[] = [
  ...FRONTOFFICE_ROLE_CODES,
];
export const ALLOWED_ROLE_CODES_FOR_FRONTOFFICE_INVITATION: ApiRoleCode[] = [
  ...FRONTOFFICE_ROLE_CODES,
];

export const ALLOWED_ROLE_CODES_FOR_FRONTOFFICE_USER_EDITION: ApiRoleCode[] = [
  ...FRONTOFFICE_ROLE_CODES,
];

export type BackOfficeApiRoleCode = (typeof BACKOFFICE_ROLE_CODES)[number];
export type FrontOfficeApiRoleCode = (typeof FRONTOFFICE_ROLE_CODES)[number];
export type ApiRoleCode = FrontOfficeApiRoleCode | BackOfficeApiRoleCode;

export type BaseApiRole = {
  code: ApiRoleCode;
  label: string;
};

export const isBackOfficeRoleCode = (roleCode: ApiRoleCode | undefined): boolean =>
  !!roleCode && (BACKOFFICE_ROLE_CODES as readonly ApiRoleCode[]).includes(roleCode);

export const isFrontOfficeRoleCode = (roleCode: ApiRoleCode | undefined): boolean =>
  !!roleCode && (FRONTOFFICE_ROLE_CODES as readonly ApiRoleCode[]).includes(roleCode);

export const isSuperAdminRoleCode = (roleCode: ApiRoleCode | undefined): boolean =>
  !!roleCode && (SUPER_ADMIN_ROLE_CODES as readonly ApiRoleCode[]).includes(roleCode);
